const SESSION_BOOTSTRAP_RETRY_BASE_DELAY_MS = 1200;
const SESSION_BOOTSTRAP_RETRY_MAX_DELAY_MS = 15000;

export interface SessionBootstrapRetryPlan {
    attempt: number;
    delayMs: number;
}

export const getSessionBootstrapRetryPlan = (
    previousAttempt: number
): SessionBootstrapRetryPlan => {
    const normalizedPreviousAttempt = Number.isFinite(previousAttempt)
        ? Math.max(0, Math.floor(previousAttempt))
        : 0;
    const attempt = normalizedPreviousAttempt + 1;
    const exponentialDelay =
        SESSION_BOOTSTRAP_RETRY_BASE_DELAY_MS *
        2 ** Math.min(attempt - 1, 30);

    return {
        attempt,
        delayMs: Math.min(
            exponentialDelay,
            SESSION_BOOTSTRAP_RETRY_MAX_DELAY_MS
        ),
    };
};
